module.exports = __webpack_public_path__ + "static/media/20181029_Fiche_référence_Sunchain_Projet_Prémian.23d823db.pdf";